import React, { Component } from "react";
import { withRouter, VirsionCheck } from "../../Helpers/Common"; //Include Home
import "./Getstarted.css";
import { motion } from "framer-motion";
import { SVGIcons, ImgIcons } from "../../Helpers/Common";
import BarLoader from "react-spinners/BarLoader";
import { getGeoInfo, utmTracking } from "../../Model/Users";
var SVGIcon = "";
var ImageData = "";
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then(resultData => SVGIcon = resultData)

class Getstarted extends Component {
  constructor(props) {
    super(props);
    this.state = {
      VirsionCheckData: false,
      VirsionCheckDataloaded: false,
      country: "",
    };
  }

  componentDidMount() {
    VirsionCheck().then((virsioncheckResponse) => {
      this.setState({
        VirsionCheckData: virsioncheckResponse,
        VirsionCheckDataloaded: true,
      });
    });

    getGeoInfo().then((res) => {
      this.setState({
        country: res,
      });
    });
  }

  exploreprimium() {
    this.props.navigate("/ExplorePlan");
  }

  skipfreewatch() {
    this.props.navigate("/select-topics");
  }

  render() {
    if (this.state.VirsionCheckDataloaded == false) {
      // return <div className="loader"></div>;
      return <div className="loader"><BarLoader color="#ff000f" /></div>;
    } else {
      const settings = {
        centerMode: true,
        centerPadding: "60px",
        // autoplay: true,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: "40px",
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 650,
            settings: {
              dots: true,
              arrows: false,
              centerMode: false,
              centerPadding: "40px",
              slidesToShow: 1,
            },
          },
        ],
      };
      // var Step3Data = JSON.parse(this.state.VirsionCheckData.data).data.banner_images.signup_step_1_1;
      var CheckVirsionResponse = JSON.parse(
        this.state.VirsionCheckData.data
      ).data;
      return (
        <>
          <motion.div
            className=""
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
          >
            <div className="temp4 dD-none">
              <hr className="border-red" />
              <hr />
              <div className="temp4-InnerRound50">
                <div className="temp4-InnerRound1">
                  <div className="temp4-InnerRound2" />
                </div>
              </div>
              <div className="temp4-InnerRound51">
                <div className="temp4-InnerRound1">
                  <div className="temp4-InnerRound2" />
                </div>
              </div>
              <div className="temp4-InnerRound52">
                <div className="temp4-InnerRound3" />
              </div>
            </div>
            <header>
              <div className="mainNav dD-none">
                <div className="docubayBack white pl-8">Create account</div>
                <div className="topQuestion">
                  {/*<img src={SVGIcon['help.svg']} alt="help" />*/}
                </div>
              </div>
            </header>
            <main className="dD-none">
              <section>
                <div className="homeBanner">
                  <div className="innerBanner">
                    <picture>
                      <source
                        srcSet={
                          CheckVirsionResponse.banner_images.signup_step_1_1
                            .ipad_banner_image
                        }
                        media="(min-width: 700px)"
                      />
                      <source
                        srcSet={
                          CheckVirsionResponse.banner_images.signup_step_1_1
                            .ipad_banner_image
                        }
                        media="(min-width: 768px)"
                      />
                      <source
                        srcSet={
                          CheckVirsionResponse.banner_images.signup_step_1_1
                            .banner_image_url
                        }
                        media="(min-width: 650px)"
                      />
                      <source
                        srcSet={
                          CheckVirsionResponse.banner_images.signup_step_1_1
                            .banner_image_url
                        }
                        media="(min-width: 300px)"
                      />
                      <img
                        src={
                          CheckVirsionResponse.banner_images.signup_step_1_1
                            .banner_image_url
                        }
                        alt=""
                      />
                    </picture>

                    <div className="title">
                      <h2>
                        {CheckVirsionResponse.banner_images.signup_step_1_1.text_one}
                      </h2>
                      <h1>
                        {CheckVirsionResponse.banner_images.signup_step_1_1.text_two}
                        <span className="red">&nbsp;
                          {
                            CheckVirsionResponse.banner_images.signup_step_1_1
                              .text_three
                          }
                        </span>
                      </h1>
                      <h3>
                        {CheckVirsionResponse.banner_images.signup_step_1_1.text_four}
                      </h3>
                    </div>
                  </div>
                </div>
              </section>
              <div className="temp6">
                <div className="formField mb-24">
                  <button
                    type="button"
                    id="sendEnquiryBtn"
                    className="btn-red btn-red-tab"
                    onClick={() => {
                      this.exploreprimium();
                    }}
                  >
                    Explore premium plans
                  </button>
                </div>
                {this.state.country == "IN" && localStorage.getItem("utmTrack") ?
                  <h6 style={{ color: "#18bc6c", textAlign: "center", marginBottom: "15px", marginTop: "-10px" }}>50% Discount Offer Unlocked!</h6>
                  : null}
                <div className="temp1Or temp1Orr mb-24"> Or </div>
                <div className="formField mb-0">
                  <button
                    type="button"
                    id="sendEnquiryBtn"
                    className="btn-black btn-gray white btn-red-tab"
                    onClick={() => {
                      this.skipfreewatch();
                    }}
                  >
                    Skip to watch FREE documentaries
                  </button>
                </div>
              </div>
            </main>

            {/* desktop section */}
            <div className="dD-block">
              <div className="mainNav policy-left">
                <div className="docubayLogo">
                  <img src={ImageData["docu-bay-white.png"]} alt="DocuBay Logo" />
                </div>
              </div>
              {/* <div className="bg-image">
                <img src={ImageData["getStartedBgImage.png"]} alt="Docubay" />
              </div> */}
              <div className="marqueeHead3">
                <div className="marquee-section-login">
                  <div className="marquee-login">
                    <img loading="lazy" decoding="async" data-nimg={1} src={'https://dbcms.docubay.com/signup/1595411195-billion-dollor-burst-1080x1543-270x386.jpg'} />
                    <img loading="lazy" decoding="async" data-nimg={1} src={'https://dbcms.docubay.com/signup/1595420815-epicenter-24-hours-in-wuhan-1080x1543-270x386.jpg'} />
                    <img loading="lazy" decoding="async" data-nimg={1} src={'https://dbcms.docubay.com/signup/1595410399-bastion-of-the-giants-1080x1543-270x386.jpg'} />
                    <img loading="lazy" decoding="async" data-nimg={1} src={'https://dbcms.docubay.com/signup/1605115593-chandani-the-daughter-of-the-elephant-whisperer-ipad-banner-1080x1543-270x386.jpg'} />
                    <img loading="lazy" decoding="async" data-nimg={1} src={'https://dbcms.docubay.com/signup/1609347468-the-world-according-to-amazon-ipad-banner-1080x1543-270x386.jpg'} />
                    <img loading="lazy" decoding="async" data-nimg={1} src={'https://dbcms.docubay.com/signup/1609426281-baboon-bandits-ipad-banner-1080x1543-270x386.jpg'} />
                  </div>
                  <div aria-hidden="true" className="marquee-login">
                    <img loading="lazy" decoding="async" data-nimg={1} src={'https://dbcms.docubay.com/signup/1618989852-bloodshed-on-the-riviera-ipad-banner-1080x1543-270x386.jpg'} />
                    <img loading="lazy" decoding="async" data-nimg={1} src={'https://dbcms.docubay.com/signup/1621010803-special-ops-ipad-banner-1080x1543-270x386.jpg'} />
                    <img loading="lazy" decoding="async" data-nimg={1} src={'https://dbcms.docubay.com/signup/1621613724-financing-terror-ipad-banner-1080x1543-270x386.jpg'} />
                    <img loading="lazy" decoding="async" data-nimg={1} src={'https://dbcms.docubay.com/signup/1623753405-the-rvers-ipad-banner-1080x1543-270x386.jpg'} />
                    <img loading="lazy" decoding="async" data-nimg={1} src={'https://dbcms.docubay.com/signup/1628787756-love-commandos-ipad-banner-1080x1543-270x386.jpg'} />
                    <img loading="lazy" decoding="async" data-nimg={1} src={'https://dbcms.docubay.com/signup/1632248828-harry-meghan-ipad-banner-1080x1543-270x386.jpg'} />
                  </div>
                </div>
                <div className="marquee-section-login1">
                  <div className="marquee-login1">
                    <img loading="lazy" decoding="async" data-nimg={1} src={'https://dbcms.docubay.com/signup/1634135160-jellyfish-the-creature-of-the-century-1080x1543-270x386.jpg'} />
                    <img loading="lazy" decoding="async" data-nimg={1} src={'https://dbcms.docubay.com/signup/1634547665-ayni-the-great-condor-odyssey-1080x1543-270x386.jpg'} />
                    <img loading="lazy" decoding="async" data-nimg={1} src={'https://dbcms.docubay.com/signup/1637766060-unnamed-270x386.jpg'} />
                    <img loading="lazy" decoding="async" data-nimg={1} src={'https://dbcms.docubay.com/signup/1638890147-the-opium-war-1080x1543-270x386.jpg'} />
                    <img loading="lazy" decoding="async" data-nimg={1} src={'https://dbcms.docubay.com/signup/1645809931-fishing-girl-1080x1543-270x386.jpg'} />
                    <img loading="lazy" decoding="async" data-nimg={1} src={'https://dbcms.docubay.com/signup/1648049572-chanel-no-5-1080x1543-270x386.jpg'} />
                  </div>
                  <div aria-hidden="true" className="marquee-login1">
                    <img loading="lazy" decoding="async" data-nimg={1} src={'https://dbcms.docubay.com/signup/1650026245-myths-monsters-war-1080x1543-270x386.jpg'} />
                    <img loading="lazy" decoding="async" data-nimg={1} src={'https://dbcms.docubay.com/signup/1655217212-saving-deserts-bride-1080x1543-270x386.jpg'} />
                    <img loading="lazy" decoding="async" data-nimg={1} src={'https://dbcms.docubay.com/signup/1632333957-deep-web-ipad-banner-1080x1543-270x386.jpg'} />
                    <img loading="lazy" decoding="async" data-nimg={1} src={'https://dbcms.docubay.com/signup/1672912290-slovakia-the-murdered-lovers-1080x1543-270x386.jpg'} />
                    <img loading="lazy" decoding="async" data-nimg={1} src={'https://dbcms.docubay.com/signup/1674814711-master-of-bees-sacred-bees-1080x1543-270x386.jpg'} />
                    <img loading="lazy" decoding="async" data-nimg={1} src={'https://dbcms.docubay.com/signup/1675246374-the-time-factory-1080x1543-270x386.jpg'} />
                  </div>
                </div>
              </div>
              <div className="blur-image">
                <div className="temp4 temp4-top dD-block">
                  <hr className="border-red" />
                  <hr />
                  <div className="temp4-InnerRound50">
                    <div className="temp4-InnerRound1">
                      <div className="temp4-InnerRound2" />
                    </div>
                  </div>
                  <div className="temp4-InnerRound51">
                    <div className="temp4-InnerRound1">
                      <div className="temp4-InnerRound2" />
                    </div>
                  </div>
                  <div className="temp4-InnerRound52">
                    <div className="temp4-InnerRound3" />
                  </div>
                </div>
                <div className="title temp5-TitAbsul">
                  <h2 className="line-height">Exclusive &amp; Premium</h2>
                  <h1 className="mb-20"><span className="red"> Documentries </span></h1>
                  <h4>Alternatively check out some of our FREE documentaries.<br />
                    No credit card needed!</h4>
                </div>
                <div className="temp6">
                  <div className="formField mb-24">
                    <button type="submit" id="sendEnquiryBtn" className="btn-red"
                      onClick={() => {
                        this.exploreprimium();
                      }}>
                      Explore premium plans
                    </button>
                  </div>
                  <div className="formField mb-0">
                    {this.state.country == "IN" && localStorage.getItem("utmTrack") ?
                      <h6 style={{ color: "#18bc6c", textAlign: "center", marginBottom: "15px", marginTop: "-10px" }}>50% Discount Offer Unlocked!</h6>
                      : null}
                  </div>
                  <div className="temp1Or mb-24"> OR </div>
                  <div className="formField mb-0">
                    <button type="submit" id="sendEnquiryBtn" className="btn-black btn-gray white"
                      onClick={() => {
                        this.skipfreewatch();
                      }}>
                      Skip to watch FREE documentaries
                    </button>
                  </div>
                </div>
                {/* </div> */}
              </div>

            </div>
          </motion.div>
        </>
      );
    }
  }
}

export default withRouter(Getstarted);
